import * as Sentry from "@sentry/react";

/**
 * Normalize an unknown failure, report it to Sentry, and return the Error for rethrow or UI.
 */
export function reportRuntimeError(error: unknown): Error {
  const normalizedError =
    error instanceof Error ? error : new Error(String(error));

  Sentry.captureException(normalizedError);

  return normalizedError;
}
